import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PENDING_INVITATIONS_ROUTE } from '../shared/constants/routes';
import { AuthGuard } from '../guards/auth.guard';
import { PendingInvitationsComponent } from './pending-invitations/pending-invitations.component';

const routes: Routes = [
  {
    path: PENDING_INVITATIONS_ROUTE,
    component: PendingInvitationsComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PendingInvitationsRoutingModule {}
